var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"optional_group"},'div',_vm.currentOptionAttr.data.attr,false),[_c(_vm.typeComponent,{tag:"component",attrs:{"items":_vm.optionItems,"max":_vm.maxItem,"currentPageAttr":_vm.currentOptionAttr,"solo":"","x-small":""},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }